import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import * as GameHistoryActions from './game-history.actions';

import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GameHistoryService } from '@fantaz/shared/data-access/api';
import { MatchResultsForUserResponse } from '@fantaz/shared/data-access/models';

@Injectable()
export class GameHistoryEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GameHistoryActions.loadGameHistory),
        switchMap(({ params }) => {
          return this.gameHistoryApiService.getGameHistory(params).pipe(
            map((data: MatchResultsForUserResponse) => {
              return GameHistoryActions.loadGameHistorySuccess({
                gameHistory: data,
              });
            }),
            catchError((error) => {
              return of(GameHistoryActions.loadGameHistoryFailure({ error }));
            }),
          );
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private readonly actions$: Actions,
    private gameHistoryApiService: GameHistoryService,
  ) {}
}
